import { Component, Input } from '@angular/core';

@Component({
  selector: 'shared-unit-value-icon',
  templateUrl: './units-value-icon.component.html',
  styleUrls: ['./units-value-icon.component.scss'],
  host: { class: 'units-value-icon' },
})
export class SharedUnitsValueIconsComponent {
  @Input() isCore = false;
  @Input() element: any;

  generateUnitsTip(phase: any): string {
    if (phase.units.currency.id == 'CoreSmb') {
      const units = (phase.units.totalUnits / 12) * 15;
      return units.toFixed(2) + ' responsive units';
    }

    return phase.units.totalUnits.toFixed(2) + ' responsive units';
  }
}
